import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Redirect, Route, Switch, useLocation, useRouteMatch, } from 'react-router-dom';
import { makePath } from 'shared';
import { AddBankAccount, ConnectBankAccount, SelectBankAccount } from './views';
function Routes() {
    const { path } = useRouteMatch();
    const location = useLocation();
    return (_jsxs(Switch, { children: [_jsx(Route, { exact: true, path: makePath(path, '/add-bank-account'), children: _jsx(AddBankAccount, {}) }), _jsx(Route, { exact: true, path: makePath(path, '/connect'), children: _jsx(ConnectBankAccount, {}) }), _jsx(Route, { exact: true, path: makePath(path, '/'), children: _jsx(SelectBankAccount, {}) }), _jsx(Route, { path: "*", children: _jsx(Redirect, { to: { pathname: makePath(path, '/'), search: location.search } }) })] }));
}
export default Routes;
